import { getNamesMap, splitNames, getWs } from '../lib'

/** @type {_restream.Rule} */
const detectNamed = {
  re: /^( *export\s+{([^}]+?)} *)(\n?)/gm,
  replacement,
}

/**
 * @suppress {globalThis}
 * @type {_alamode.ÀLaModeReplacer}
 */
function replacement(match, exportsSeg, names, newLine) {
  const sn = splitNames(names)
  const n = getNamesMap(sn)

  this.emit('export', n)
  if (this.noSourceMaps) return ''
  const ws = getWs(exportsSeg)
  const nl = newLine ? newLine : ''
  const res = `${ws}${nl}`
  return res
}

export default detectNamed

/**
 * @suppress {nonStandardJsDocs}
 * @typedef {import('restream').Rule} _restream.Rule
 */
/**
 * @suppress {nonStandardJsDocs}
 * @typedef {import('alamode/types').ÀLaModeReplacer} _alamode.ÀLaModeReplacer
 */